
<app-breadcrumb current="Produtos" [(links)]="links"></app-breadcrumb>
<!--New Products-->
<div class="backgroundColor mine-shaft base">
  <section class="container-fluid backgroundColor mine-shaft base d-flex align-items-center position-relative top-119">
    <div class="col-md-12 no-padd">
      <div id="row" class="container">
        <div class="row pt-20">
          <div class="col-md-12">
            <div class="bg-yellow-gradient text-shadow">
              <h1 class="py-2 m-6 mt-16 mb-16 a-font-style font-italic textColor black">Produtos</h1>
            </div>
          </div>
          <div class="col-md-12">
            <div id="accordion" class="myaccordion model-border">
              <div class="card border harvest-gold base">
                <div class="card-header desc-border-bottom" id="headingOne">
                  <h2 class="mb-0">
                    <button type="button" class="d-flex align-items-center justify-content-between btn btn-link" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne" (click)="changePM()">
                      <span class="h2 text-white mt-2 font-italic">Filtros de Pesquisa</span>
                      <span class="fa-stack fa-sm" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne"  *ngIf="!pm_ctrl">
                        <fa-icon [icon]="faCircle" class="fas fa-circle fa-stack-2x"></fa-icon>
                        <fa-icon [icon]="faPlus" class="fas fa-plus fa-stack-1x fa-inverse"></fa-icon>
                      </span>
                      <span class="fa-stack fa-sm" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne"  *ngIf="pm_ctrl">
                        <fa-icon [icon]="faCircle" class="fas fa-circle fa-stack-2x"></fa-icon>
                        <fa-icon [icon]="faMinus" class="fas fa-plus fa-stack-1x fa-inverse"></fa-icon>
                      </span>
                    </button>
                  </h2>
                </div>
                <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
                  <div class="card-body d-flex align-items-center flex-wrap">
                    <div class="col-md-4 border-right border-bottom">
                      <ul class="list-group list-group-flush text-white">
                        <li class="list-group-item no-padd d-table text-left"><span>Alta Relojoaria</span><input class="form-control col-3 " type="checkbox" style="height: 25px;" (click)="push('alta')" [checked]="tInput.includes('alta')"></li>
                      </ul>
                      <ul class="list-group list-group-flush text-white">
                        <li class="list-group-item no-padd d-table text-left"><span>Relojoaria</span><input class="form-control col-3 " type="checkbox" style="height: 25px;" (click)="push('relogio')" [checked]="tInput.includes('relogio')"></li>
                      </ul>
                    </div>
                    <div class="col-md-4 border-right border-bottom">
                      <ul class="list-group list-group-flush text-white">
                        <li class="list-group-item no-padd d-table text-left"><span>Joalharia</span><input class="form-control col-3 " type="checkbox" style="height: 25px;" (click)="push('j1')" [checked]="tInput.includes('j1')"></li>
                      </ul>
                      <ul class="list-group list-group-flush text-white">
                        <li class="list-group-item no-padd d-table text-left"><span>Pratas</span><input class="form-control col-3 " type="checkbox" style="height: 25px;" (click)="push('j2')" [checked]="tInput.includes('j2')"></li>
                      </ul>
                    </div>
                    <div class="col-md-3">
                      <ul class="list-group list-group-flush text-white">
                        <li class="list-group-item no-padd d-table text-left"><span>Acessórios</span><input class="form-control col-3 " type="checkbox" style="height: 25px;" (click)="push('acess')" [checked]="tInput.includes('acess')"></li>
                      </ul>
                      <ul class="list-group list-group-flush text-white">
                        <li class="list-group-item no-padd d-table text-left"><br></li>
                      </ul>
                    </div>
                    <div class="col-md-12 d-flex justify-content-center mt-10">
                      <button type="button" class="btn btn-secondary py-2 col-12 col-md-2 border-all" data-toggle="modal" data-target="#staticBackdrop">
                        Marcas
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row text-center col-12 mt-20">
            <ng-container *ngFor="let item of display">
              <div class="col-md-6 col-lg-4 col-xl-3 col-12 mt-3 mb-1 card-expand">
                <div class="card card-w-h shadow-card">
                  <div class="">
                    <img src="https://{{apiUrl}}/api/produtos/image/{{item.id}}/{{item.media.split(';')[0]}}" class="card-img-top backgroundColor img-h white base img-fluid rounded-0" alt="...">
                  </div>
                  <div class="card-body list-inline">
                    <h2 class="card-text textColor harvest-gold darken-1 card-text-limit font-italic mb-4">{{getMarca(item)}}</h2>
                    <h2 class="card-text text-white card-text-limit font-italic h-16">{{item.nome}}</h2>
                    <h2 class="card-text text-white card-text-limit mt-4 font-italic"></h2>
                    <div class="d-flex justify-content-around  align-items-baseline position-relative">
                      <p class="card-text list-inline-item textColor new-orleans base position-relative">Sob consulta €</p>
                      <a href="/produtos/modelo{{crums}}&id={{item.id}}" class="btn btn-grad list-inline-item position-relative">Ver Mais</a>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
        <div class="d-flex justify-content-center mt-20">
          <app-pagination [(current)]="current" [(pags)]="pags" [(total)]="list" [(display)]="display"></app-pagination>
        </div>
      </div>
    </div>
  </section>
</div>

<!-- Modal -->
<div class="modal fade" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title" id="staticBackdropLabel">Selecione as marcas que pretende visualizar</h2>
      </div>
      <div class="modal-body d-flex flex-column ">
        <ng-container *ngFor="let row of marcas | toMatrix:splitVal; let c = index">
          <div class="col-md-4">
            <ul class="list-group list-group-flush boxes">
              <ng-container *ngFor="let col of row; let i = index">
                <li class="list-group-item d-table text-left">
                  <input type="checkbox" id="box-{{c}}-{{i}}" (click)="push(col)" [checked]="checkEqual(mId, col.id)"><label for="box-{{c}}-{{i}}">{{col}}</label>
                </li>
              </ng-container>
            </ul>
          </div>
        </ng-container>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="clearMarcas()">Limpar Seleção</button>
        <button type="button" class="btn btn-primary px-4" data-dismiss="modal" aria-label="Close">Filtrar</button>
      </div>
    </div>
  </div>
</div>